import { render, staticRenderFns } from "./customer-order.vue?vue&type=template&id=a8f264fc&scoped=true"
import script from "./customer-order.vue?vue&type=script&lang=js"
export * from "./customer-order.vue?vue&type=script&lang=js"
import style0 from "./customer-order.vue?vue&type=style&index=0&id=a8f264fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f264fc",
  null
  
)

export default component.exports